import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { handleApiError } from "../handleApiError";
import axiosInstance from "../axiosInstance";

const API_URL = "/ranked";

// ---------------- GET ALL ----------------
export const getRanked = createAsyncThunk(
  "ranked/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams();

      if (params.page) query.append("page", params.page);
      if (params.limit) query.append("limit", params.limit);
      if (params.search) query.append("search", params.search);

      const response = await axiosInstance.get(
        `${API_URL}?${query.toString()}`,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- GET ONE ----------------
export const getOneRanked = createAsyncThunk(
  "ranked/getOne",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- ADD ----------------
export const addRanked = createAsyncThunk(
  "ranked/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${API_URL}`, data);
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- UPDATE ----------------
export const updateRanked = createAsyncThunk(
  "ranked/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/${id}`, data);
      toast.success("تم التحديث");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- DELETE ----------------
export const deleteRanked = createAsyncThunk(
  "ranked/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${API_URL}/${id}`);
      toast.success("تم الحذف");
      return { id };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ---------------- TOGGLE ACTIVE ----------------
export const toggleRankedActive = createAsyncThunk(
  "ranked/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      // console.log("Toggling active for ID:", id); // Debug log
      await axiosInstance.patch(`${API_URL}/toggle-active/${id}`);
      return id;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
